//FUNCTIONS RELATED TO LOADING
//Hides loadingIcon and loadingScreenBG
const loadingScreenDOMIds = [
	"loadingOverlay",
	"loadingScreenBG",

	"loadingRing",
	"dotsContainer",
	"game_logo_container",

	"circularProgress",

	//For live
	"loadingIcon",
	"logo",

	// New on V2
	"loadingScreenV2PortraitBG",
	"loadingScreenV2LandscapeBG",
	"loadingScreenV2Text"
];

/**
 * Hide loading screen
 * Note: always place this snippet on final loaded component
 */
function hideLoadingScreen() {
	let dom: HTMLElement | null;

	for (const id of loadingScreenDOMIds) {
		dom = document.getElementById(id);
		if (!dom) continue;
		dom.style.display = "none";
	}
}

function resetLoadingScreen(): void {
	// console.log("rLS");
	let dom: HTMLElement | null;

	for (const id of loadingScreenDOMIds) {
		dom = document.getElementById(id);
		if (!dom) continue;
		dom.style.display = "";
	}

	// loadingScreenDOMIds.forEach(item => {
	// 	dom = document.getElementById(item);
	// 	if (!dom) return;

	// 	dom.style.display = "";
	// });
}

export {
	hideLoadingScreen,
	resetLoadingScreen
}
